import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js';
import { memo } from 'react';
import { Doughnut } from 'react-chartjs-2';

import { WorkOrderData } from '../../../../api/workOrders/types';
import { CHART_TITLES } from '../../constants';
import { groupByClientKind } from '../../utils/aggregations';
import { ChartCard } from '../ChartCard';

ChartJS.register(ArcElement, Tooltip, Legend);

const PALETTE = [
  '#7B3FF2',
  '#1976D2',
  '#43A047',
  '#F9A825',
  '#00897B',
  '#B71C1C',
  '#5E35B1',
  '#039BE5',
  '#616161',
  '#9E9E9E',
];

interface ClientKindDonutProps {
  data: WorkOrderData[];
}

function ClientKindDonutImpl({ data }: ClientKindDonutProps): JSX.Element {
  const stats = groupByClientKind(data);
  const chartData = {
    labels: stats.map((s) => s.label),
    datasets: [
      {
        data: stats.map((s) => s.count),
        backgroundColor: stats.map((_, i) => PALETTE[i % PALETTE.length]),
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: 'bottom' as const, labels: { boxWidth: 12 } },
    },
  };

  return (
    <ChartCard
      title={CHART_TITLES.clientKindDonut}
      ariaLabel={`Distribuição por tipo de cliente: ${stats
        .map((s) => `${s.label} ${s.count}`)
        .join(', ')}.`}
    >
      <Doughnut data={chartData} options={options} />
    </ChartCard>
  );
}

export const ClientKindDonut = memo(ClientKindDonutImpl);
